const uuid = require('./uuid.js')
module.exports = function HistoryItem (props) {
  return {
    id: uuid(),
    ...props
  }
}
